import axios from 'axios'
import { serializeParams } from '../utils/genericUtils'

export default {
  namespaced: true,
  // getters,
  actions: {
    // create schedule
    listSchedule(context, params) {
      return axios({
        url: process.env.VUE_APP_URL + '/staffSchedule',
        method: 'GET',
        params,
      })
    },
    createSchedule(context, data) {
      return axios({
        url: process.env.VUE_APP_URL + '/staffSchedule',
        method: 'POST',
        data,
      })
    },
    retrieveSchedule(context, idSchedule) {
      return axios({
        url: process.env.VUE_APP_URL + '/staffSchedule/' + idSchedule,
        method: 'GET',
      })
    },
    deleteSchedule(context, idSchedule) {
      return axios({
        url: process.env.VUE_APP_URL + '/staffSchedule/' + idSchedule,
        method: 'DELETE',
      })
    },
    editSchedule(context, { idSchedule, data }) {
      return axios({
        url: process.env.VUE_APP_URL + '/staffSchedule/' + idSchedule,
        method: 'PUT',
        data,
      })
    },
    editStatusSchedule(_, data) {
      return axios({
        url:
          process.env.VUE_APP_URL +
          `/staffSchedule/attendance/${data.idSchedule}/type`,
        method: 'PUT',
        data: data.body,
      })
    },

    listPendingEmployee(_, { idSchedule, query }) {
      return axios({
        url:
          process.env.VUE_APP_URL +
          `/staffSchedule/collaborators/pending${query ? `?${query}` : '/'}`,
        method: 'GET',
      })
    },
    listBelongAndPendingEmployee(_, { idSchedule, query }) {
      return axios({
        url:
          process.env.VUE_APP_URL +
          `/staffSchedule/${idSchedule}/collaborators${
            query ? `?${query}` : '/'
          }`,
        method: 'GET',
      })
    },

    // reports
    listAttendance(_, params) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/staffSchedule/attendance${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getRolesAttendanceCount(_, params) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/staffSchedule/attendance/statistics${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getRolesAttendance(_, params) {
      return axios({
        url: process.env.VUE_APP_URL + '/staffSchedule/attendance/webroles',
        method: 'GET',
        params,
      })
    },
    downloadReportPDF(_, params) {
      axios.defaults.headers.common['Accept'] = 'application/octet-stream'
      axios.defaults.headers.common['Content-Type'] = 'application/octet-stream'
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/staffSchedule/attendance/report/pdf${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
        .then((res) => {
          delete axios.defaults.headers.common['Accept']
          delete axios.defaults.headers.common['Content-Type']
          axios.defaults.headers.common['Accept'] = 'application/json'
          return res
        })
        .catch((e) => {
          delete axios.defaults.headers.common['Accept']
          delete axios.defaults.headers.common['Content-Type']
          axios.defaults.headers.common['Accept'] = 'application/json'
          return Promise.reject(e)
        })
    },
    downloadReportXLSX(_, params) {
      axios.defaults.headers.common['Accept'] = 'application/octet-stream'
      axios.defaults.headers.common['Content-Type'] = 'application/octet-stream'
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/staffSchedule/attendance/report/xlsx${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
        .then((res) => {
          delete axios.defaults.headers.common['Accept']
          delete axios.defaults.headers.common['Content-Type']
          axios.defaults.headers.common['Accept'] = 'application/json'
          return res
        })
        .catch((e) => {
          delete axios.defaults.headers.common['Accept']
          delete axios.defaults.headers.common['Content-Type']
          axios.defaults.headers.common['Accept'] = 'application/json'
          return Promise.reject(e)
        })
    },
    addNote(_, { idAttendance, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/staffSchedule/attendance/${idAttendance}/notes`,
        method: 'POST',
        data,
      })
    },
    editNote(_, { idAttendance, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/staffSchedule/attendance/${idAttendance}/notes`,
        method: 'PUT',
        data,
      })
    },
    deleteNote(_, idAttendance) {
      return axios({
        url: `${process.env.VUE_APP_URL}/staffSchedule/attendance/${idAttendance}/notes`,
        method: 'DELETE',
      })
    },
  },
}
